import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue';
import { i18n, setLocale } from '@/boot/i18n';

type Locale = 'ru'|'mn'|'es'


export default /*#__PURE__*/_defineComponent({
  __name: 'Lang',
  setup(__props) {

const loc = computed<Locale>({
  get: () => i18n.global.locale.value as Locale,
  set: (v) => {
    setLocale(v).then(() => window.location.reload());
  },
});

const opts = [
  { label: 'Русский', value: 'ru' },
  { label: 'Монгол', value: 'mn' },
  { label: 'Español', value: 'es' },
];

return (_ctx: any,_cache: any) => {
  const _component_q_select = _resolveComponent("q-select")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_q_select, {
      modelValue: loc.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((loc).value = $event)),
      options: opts,
      class: "block",
      "option-value": "value",
      "option-label": "label",
      "emit-value": "",
      "map-options": "",
      dense: "",
      label: _ctx.$t('selectLang')
    }, null, 8, ["modelValue", "label"])
  ]))
}
}

})